import React, { useState } from "react";
import "./AboutValues.scss";
import { valuesData } from "../../data/data";

import { ReactComponent as ArrUp } from "../../assets/svg/ArrUp.svg";
import { ReactComponent as ArrDown } from "../../assets/svg/Arr-down.svg";

const AboutValues = () => {
  const [selectedHeaderIndex, setSelectedHeaderIndex] = useState(0);
  const [showAnswers, setShowAnswers] = useState(
    Array(valuesData.length).fill(false)
  );

  const toggleValues = (index) => {
    setShowAnswers((prevShowAnswers) => {
      const newShowAnswers = prevShowAnswers.map((value, idx) => {
        return idx === index ? !value : false;
      });
      return newShowAnswers;
    });

    setSelectedHeaderIndex(index);
  };

  const handleIconClick = (index) => {
    toggleValues(index);
  };

  const handleHeaderClick = (index) => {
    setSelectedHeaderIndex(index);
  };

  return (
    <section className="section aboutValues">
      <article className="aboutValues__container container">
        <div className="aboutValues__container--dropdown">
          <div className="dropdown__header">
            <h3>
              Values That <br />
              <span> Sets Us Apart</span>
            </h3>
          </div>
          <div className="dropdown__values">
            {valuesData.map((skills, index) => {
              const { title, description } = skills;
              const isOpen = showAnswers[index];

              return (
                <div className="dropdown__values--items" key={title}>
                  <div className="dropdown__values--items-header">
                    <h3
                      className={
                        selectedHeaderIndex === index
                          ? "items-title active-items-title"
                          : "items-title"
                      }
                      onClick={() => handleHeaderClick(index)}
                    >
                      {title}
                    </h3>
                    <button
                      type="button"
                      className="open-values-btn"
                      onClick={() => handleIconClick(index)}
                    >
                      {isOpen ? <ArrUp /> : <ArrDown />}
                    </button>
                  </div>

                  {isOpen && (
                    <p className="dropdown__values--items-text">
                      {description}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="aboutValues__container--img">
          {selectedHeaderIndex !== null && (
            <>
              <h3 className="aboutValues-img-title">
                {valuesData[selectedHeaderIndex].titleUp}
              </h3>
              <img
                src={valuesData[selectedHeaderIndex].img}
                width={450}
                height={200}
                title="Radiksez Values Image"
                alt={`AboutValues ${selectedHeaderIndex + 1}`}
                className="aboutValues-img-img fade-in"
              />
              <h3 className="aboutValues-img-subtitle">
                {valuesData[selectedHeaderIndex].titleDown}
              </h3>
              <p className="aboutValues-img-text">
                {valuesData[selectedHeaderIndex].description}
              </p>
            </>
          )}
        </div>
      </article>
    </section>
  );
};

export default AboutValues;
